module.exports = __webpack_public_path__ + "static/media/IngredientImagePlaceholder1.2be46f9a.png";